import {FormikProps} from 'formik';
import SelectOutlet from '../../../../components/selectOutlet';
import {InputGroupCodes} from '../../../../utilities/inputGroupCodes';
import {formulationTypesRadio} from '../../advertisementRegisteration/constants';
import {IProductForm} from './productFormData';

interface IProps {
  form: FormikProps<IProductForm>;
}

const SelectFormulation = ({form}: IProps) => {
  const Options = formulationTypesRadio[InputGroupCodes.FertilizerCode]?.map(
    item => ({
      label: item.title,
      value: item.value,
    }),
  );

  return (
    <section>
      <p className="mb-2 color-gray-1 text-md">فرمولاسیون</p>

      <SelectOutlet
        name="formulation"
        label=""
        value={form?.values.formulation!}
        options={Options || []}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          form.setFieldValue('formulation', e.target.value)
        }
      />
    </section>
  );
};

export default SelectFormulation;
